import React from "react";
import { ToolbarButton, Image } from "@fluentui/react-components";
import { useHomeStyles } from "./style/home.style";

const HomeOnline = () => {
  const styles = useHomeStyles();

  function showPopup() {
    const url = "/taskpane.html?Popup=true";
    const fullUrl =
      window.location.protocol +
      "//" +
      window.location.hostname +
      (window.location.port ? ":" + window.location.port : "") +
      url;
    Office.context.ui.displayDialogAsync(fullUrl, { displayInIframe: false, height: 70, width: 30 }, (asyncResult) => {
      if (asyncResult.status !== Office.AsyncResultStatus.Succeeded || !asyncResult.value) {
        console.log("Failed to open login popup", asyncResult.error);
        return;
      }

      const dialog = asyncResult.value;
      dialog.addEventHandler(Office.EventType.DialogMessageReceived, (arg) => {
        try {
          if ("message" in arg) {
            const message = JSON.parse(arg.message);

            // Copy local storage data from popup to parent
            if (message.localStorage) {
              Object.keys(message.localStorage).forEach((key) => {
                const value = message.localStorage[key];
                if (value !== null && value !== undefined) {
                  window.localStorage.setItem(key, value);
                }
              });
              console.log("Local storage data copied from popup to parent");
            }

            if (message.type === "profileSelected") {
              dialog.close();
              window.location.href = "/taskpane.html?Popup=false";
            }
          }
        } catch (error) {
          console.error("Error processing message:", error);
          dialog.close();
          window.location.href = "/taskpane.html";
        }
      });
    });
  }

  return (
    <>
      <div className={styles.loginwrapper}>
        <div className={styles.logincontentwrapper}>
          <div title="MSCI Inc." id="custom-prompt-logoheader" className={styles.header}></div>

          <div title="MSCI Inc." id="custom-prompt-logo" className={styles.header}></div>
          <div className={styles.logo}>
            <Image alt="MSCI Inc." src="https://static-qa.msci.com/images/MSCI2019Logo.svg" />{" "}
          </div>
          <div>
            <h2 className={styles.h2}>Sign In </h2>
          </div>
          <div>
            <p className={styles.p}>
              Sign in using your <br></br>corporate credentials
            </p>
          </div>

          <div className={styles.loginDiv}>
            <ToolbarButton className={styles.loginButton} onClick={() => showPopup()}>
              Continue
            </ToolbarButton>
          </div>
        </div>
      </div>
    </>
  );
};
export default HomeOnline;
